import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/2c9d3aed-ff3e-4438-ad9c-3e77ca0159b1";
export const REGISTER_URL = "https://a.ntrk2.com/ae58b9ac-88b7-425c-881a-6f5ff0337b73";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://ck268.loadprkw2a.com/download?openExternalBrowser=1&id=a3lahiachk0t7nw";

export * from "./codes";
export * from "./context";
